import { PlanSelection } from "@/components/setup/plan-selection";
import { SetupFormPaymentMethod } from "@/components/setup/setup-form-payment-method";
import DialogInviteBilling from "@/components/team/dialog-invite-billing";
import { Button } from "@/components/ui/button";
import { useStepper } from "@/components/ui/stepper";
import { useTeams } from "@/contexts/teams-provider";
import { useLocalStorage } from "@/hooks/useStorage";
import { useTranslation } from "@/hooks/useTranslation";
import { SetupTeamCreationInfosDTO, SubscriptionType } from "@shaarp/common";
import { useState } from "react";

export const SetupTeamCreationPaymentMethodPage = () => {
  const { nextStep, setStep } = useStepper();
  const { teamSelected } = useTeams();
  const { t } = useTranslation();
  const [setupTeamCreationInfosDatas] =
    useLocalStorage<SetupTeamCreationInfosDTO>("setup-team-creation-infos");

  const [openDialogInvitation, setOpenDialogInvitation] = useState(false);

  const monthlyFloor = teamSelected?.initialProLicenseCountMonthly || 1;
  const annualFloor = teamSelected?.initialProLicenseCountAnnual || 1;
  const [subscriptionType, setSubscriptionType] = useState<SubscriptionType>(
    teamSelected?.defaultBillingFrequency || "monthly"
  );
  const [pendingProLicenseCount, setPendingProLicenseCount] = useState<number>(
    (teamSelected?.defaultBillingFrequency || "monthly") === "annual"
      ? annualFloor
      : monthlyFloor
  );

  const onInviteBillingCompleted = () => {
    setOpenDialogInvitation(false);
  };

  const onCompleted = () => {
    nextStep();
  };

  const goBackStep = () => {
    if (
      setupTeamCreationInfosDatas?.siret ||
      setupTeamCreationInfosDatas?.website
    ) {
      setStep(4);
    } else {
      setStep(2);
    }
  };

  return (
    <div className="space-y-7 w-full">
      <h1 className="text-2xl font-bold text-center text-primary">
        {t("setup.teamCreation.paymentMethod.title")}
      </h1>

      <div className="grid grid-cols-1 gap-8 lg:grid-cols-2">
        <PlanSelection
          defaultSubscriptionType={subscriptionType}
          defaultProLicenseCountMonthly={
            teamSelected?.initialProLicenseCountMonthly
          }
          defaultProLicenseCountAnnual={
            teamSelected?.initialProLicenseCountAnnual
          }
          onSubscriptionTypeChange={setSubscriptionType}
          onPendingProLicenseCountChange={setPendingProLicenseCount}
        />

        <div className="space-y-4">
          <p className="text-sm">
            {t("setup.teamCreation.paymentMethod.payment.instruction")}
          </p>

          <p className="text-sm">
            {t("setup.teamCreation.paymentMethod.payment.alternate")}
          </p>
          <div className="text-center">
            <Button
              onClick={() => setOpenDialogInvitation(true)}
              variant="outline"
            >
              {t("setup.teamCreation.paymentMethod.payment.inviteButton")}
            </Button>
          </div>

          <SetupFormPaymentMethod
            additionnalButtons={
              <>
                <Button onClick={() => goBackStep()} variant="outline">
                  {t("setup.teamCreation.paymentMethod.buttons.previous")}
                </Button>
              </>
            }
            onCompleted={onCompleted}
            subscriptionType={subscriptionType}
            pendingProLicenseCount={pendingProLicenseCount}
          />
        </div>
      </div>

      {openDialogInvitation && (
        <DialogInviteBilling
          onClose={() => setOpenDialogInvitation(false)}
          onCompleted={onInviteBillingCompleted}
          pendingProLicenseCount={pendingProLicenseCount}
          subscriptionType={subscriptionType}
        />
      )}
    </div>
  );
};
